import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Banner } from '@app/shared/models/app.model';
import { SettingsService } from '@app/services/settings.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-information-banner',
  templateUrl: './information-banner.component.html',
  styleUrls: ['./information-banner.component.scss'],
})
export class InformationBannerComponent {
  @Input() banner: Banner;
  @Output() closeBanner = new EventEmitter<void>();
  public langauge: string;
  public isOpen = true;

  constructor(translate: TranslocoService, private settings: SettingsService) {
    this.langauge = translate.getActiveLang();
  }

  close() {
    const tempSettings = this.settings.localSettings;
    if (!tempSettings.closedBanners.includes(this.banner.documentID)) {
      tempSettings.closedBanners.push(this.banner.documentID);
      this.settings.updateLocalSettings(tempSettings);
    }
    this.closeBanner.emit();
    this.isOpen = false;
  }
}
